(function () {
  try {
    window.__STOCKSTORM_HEAD = (window.__STOCKSTORM_HEAD || {});
    window.__STOCKSTORM_HEAD.desktop = true;
    if (typeof console !== 'undefined' && console.log) {
      console.log('StockStorm: desktop head bundle loaded');
    }

    const params = new URLSearchParams(location.search);
    var mv = params.get('mv');
    var shouldLoad = (mv === null || mv === '' || mv === '1' || String(mv).toLowerCase() === 'true');
    
    const isMobile = /(iPhone|iPad|iPod|Android|Mobi|Tablet)/i.test(navigator.userAgent);
    const isRetinaMobile = isMobile && window.devicePixelRatio && window.devicePixelRatio >= 2;
    const isDesktop = document.documentElement.classList.contains('desktop-scaled-page');

    let storedQualityLevel = null;
    let storedGlow = false;
    try {
      const rawSettings = localStorage.getItem('mainSettings');
      const rawConfig = localStorage.getItem('configureControlSettings');
      if (rawSettings) storedQualityLevel = JSON.parse(rawSettings)?.value?.quality;
      if (rawConfig) storedGlow = JSON.parse(rawConfig)?.value?.value?.isGlowOn;
    } catch (e) {}

    const activeQualityLevel = storedQualityLevel || (isMobile ? 'performance' : 'quality');
    const isQuality = activeQualityLevel === 'quality';

    if (isMobile) {
      window.__STOCKSTORM_HEAD.nativeDevicePixelRatio = window.devicePixelRatio || 1;
      try {
        Object.defineProperty(window, 'devicePixelRatio', {
          get: function () { return 2; },
          configurable: true
        });
      } catch (e) {
        window.devicePixelRatio = 2;
      }
    }

    window.__STOCKSTORM_CONFIG = {
      glow: !!storedGlow,
      mv: shouldLoad,
      bloom: params.has('bloom') ? (params.get('bloom') !== '0' && params.get('bloom') !== 'false') : isQuality,
      pixelRatio: parseFloat(params.get('pr')) || (isMobile ? window.devicePixelRatio : Math.max(window.devicePixelRatio || 1, 1.5)),
      antialias: params.has('aa') ? (params.get('aa') !== '0' && params.get('aa') !== 'false') : isQuality,
      highRefreshRate: params.has('hrr') ? (params.get('hrr') !== '0' && params.get('hrr') !== 'false') : isQuality,
      foveationLevel: params.has('fl') ? parseInt(params.get('fl')) : (isQuality ? 0 : 1),
    };
    setLevelQuality();

    if (shouldLoad) {
      var s = document.createElement('script');
      s.type = 'module';
      s.src = 'https://ajax.googleapis.com/ajax/libs/model-viewer/4.0.0/model-viewer.min.js';
      document.head.appendChild(s);
    } else {
      console.info('[MV] Skipping model-viewer load via ?mv=0');
    }
  } catch (_) { /* no-op */ }

  function setLevelQuality() {
    const scene = document.getElementById('main-scene');
    if (!scene) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', setLevelQuality);
      }
      return;
    }

    const config = window.__STOCKSTORM_CONFIG || {};

    // Set renderer tweaks
    const pr = config.pixelRatio || 1.5;
    scene.setAttribute('renderer-tweaks', 'pixelRatio: ' + pr);
    // scene.setAttribute('renderer-tweaks', 'pixelRatio: 2');

    // Set renderer
    const aa = (config.antialias !== undefined) ? config.antialias : true;
    const hrr = (config.highRefreshRate !== undefined) ? config.highRefreshRate : true;
    const fl = (config.foveationLevel !== undefined) ? config.foveationLevel : 0;
    scene.setAttribute('renderer', 'antialias: ' + aa + '; highRefreshRate: ' + hrr + '; foveationLevel: ' + fl + ';');
    
    // Set bloom
    const bloomEnabled = (config.bloom !== undefined && config.glow !== undefined) ? config.bloom && config.glow: true;
    scene.setAttribute('bloom', 'enabled: ' + bloomEnabled + '; threshold: 1; strength: 0.2; radius: 0.1;');
  }

  if (typeof AFRAME !== 'undefined') {
    AFRAME.registerComponent('renderer-tweaks', {
      schema: { pixelRatio: { type: 'number', default: (window.__STOCKSTORM_CONFIG && window.__STOCKSTORM_CONFIG.pixelRatio) || 1.5 } },
      init: function () {
        const renderer = this.el.sceneEl.renderer;
        if (renderer) {
          renderer.setPixelRatio(this.data.pixelRatio);
          console.log('Pixel Ratio Set To:', renderer.getPixelRatio());
        }
      }
    });
  }
})();
